import React, { useState, useEffect } from 'react';
import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/AdminNavbar'
import BASE_URL from 'components/BaseUrl/apiConfig';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BlockUiOverlay from 'components/Expense/BlockUiOverlay';

const AdminDetails = () => {

    const [loading, setLoading] = useState(true);

    const history = useHistory();

    useEffect(() => {
        // Check if user is not logged in (localStorage is empty)
        if (!localStorage.getItem("userData")) {
            // Redirect to the login page
            history.push("/login");
        }
    }, [history]);



    const [userData, setUserData] = useState(null);

    useEffect(() => {
        // get userId from local storage
        const storedUserData = localStorage.getItem('userData');
        let userId = '';
        if (storedUserData) {
            const userData = JSON.parse(storedUserData);
            userId = userData.userId;
        }

        // fetch user data from the API
        fetch(`${BASE_URL}/api/Users/GetUserById?userId=${userId}`)
            .then((response) => response.json())
            .then((data) => setUserData(data), setLoading(false))
            .catch((error) => console.error('Error fetching user data:', error));
    }, []); // Empty dependency array ensures the effect runs only once on component mount

    const ClickUpdateButton = (userData) => {
        history.push({
            pathname: '/updateAdminProfile',
            state: { userData }
        });
    };


    return (
        <>
            <Navbar />
            <main className="profile-page">
                <BlockUiOverlay visible={loading} />
                <section className="relative block h-350-px">
                    <div
                        className="absolute top-0 w-full h-full bg-center bg-cover"
                        style={{
                            backgroundImage:
                                "url('https://images.unsplash.com/photo-1499336315816-097655dcfbda?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2710&q=80')",
                        }}
                    >
                        <span
                            id="blackOverlay"
                            className="w-full h-full absolute opacity-50 bg-black"
                        ></span>
                    </div>
                    <div
                        className="top-auto bottom-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden h-70-px"
                        style={{ transform: "translateZ(0)" }}
                    >
                        <svg
                            className="absolute bottom-0 overflow-hidden"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="text-blueGray-200 fill-current"
                                points="2560 0 2560 100 0 100"
                            ></polygon>
                        </svg>
                    </div>
                </section>
                <section className="relative py-16 bg-blueGray-200">

                    <div className="container mx-auto px-4">
                        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-xl rounded-lg -mt-64">
                            <div className="px-6">
                                <div className="flex flex-wrap justify-center">
                                    <div className="w-full lg:w-2/12 px-4  flex justify-center">
                                        <div className="relative">
                                            {userData && userData.image ? (
                                                <img
                                                    alt="..."
                                                    src={userData.image}
                                                    className="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                                                    style={{ height: '150px', width: '150px' }}
                                                />
                                            ) : (
                                                <img
                                                    alt="..."
                                                    src={"https://img.freepik.com/free-vector/illustration-customer-service-concept_53876-5883.jpg?t=st=1712140376~exp=1712143976~hmac=7eb17cd5830e6ccaf8429cd93d73b24f4b790f5f4d8f7056fddd0afb8d6ddf08&w=740"}
                                                    className="shadow-xl rounded-full h-auto align-middle border-none absolute -m-16 -ml-20 lg:-ml-16 max-w-150-px"
                                                    style={{ height: '150px', width: '150px' }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="w-full lg:w-4/12 px-4 lg:order-3 lg:text-right lg:self-center">
                                        <div className="py-6 px-3 mt-32 sm:mt-0">
                                            <button
                                                className="bg-lightBlue-500 active:bg-lightBlue-600 uppercase text-white font-bold hover:shadow-md shadow text-xs px-4 py-2 rounded outline-none focus:outline-none sm:mr-2 mb-1 ease-linear transition-all duration-150"
                                                type="button"
                                                style={{ float: "inline-end" }}
                                                onClick={() => ClickUpdateButton(userData)}

                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                    <div className="w-full lg:w-4/12 px-4 lg:order-1">
                                        <div className="flex justify-center py-4 lg:pt-4 pt-8">
                                            <div className="mr-4 p-3 text-center">
                                                <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">

                                                </span>
                                                <span className="text-sm text-blueGray-400">

                                                </span>
                                            </div>
                                            <div className="mr-4 p-3 text-center">
                                                <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">

                                                </span>
                                                <span className="text-sm text-blueGray-400">

                                                </span>
                                            </div>
                                            <div className="lg:mr-4 p-3 text-center">
                                                <span className="text-xl font-bold block uppercase tracking-wide text-blueGray-600">

                                                </span>
                                                <span className="text-sm text-blueGray-400">

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="text-center mt-10">
                                    {userData ? (
                                        <>
                                            <h3 className="text-4xl font-semibold leading-normal mb-2 text-blueGray-700 mb-2">
                                                {userData.fullName}
                                            </h3>
                                            <div className="text-sm leading-normal mt-0 mb-2 text-blueGray-400 font-bold">
                                                <i className="fas fa-user-tie mr-2 text-lg text-blueGray-400"></i>{" "}
                                                {userData.userName}
                                            </div>
                                            <div className="mb-2 text-blueGray-600 ">
                                                <i className="fas fa-envelope mr-2 text-lg text-blueGray-400"></i>
                                                {userData.emailId}
                                            </div>
                                            <div className="mb-2 text-blueGray-600">
                                                <i className="fas fa-mobile-alt mr-2 text-lg text-blueGray-400"></i>
                                                {userData.contact}
                                            </div>

                                        </>
                                    ) : (
                                        <p></p>
                                    )}
                                </div>

                                <div className="mt-10 py-5 border-t border-blueGray-200 text-center">
                                    <div className="flex flex-wrap justify-center">
                                        <div className="w-full lg:w-9/12 px-4">
                                            <p className="mb-4 text-lg leading-relaxed text-blueGray-700">

                                            </p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}

export default AdminDetails
